module.exports = __webpack_public_path__ + "assets/img/202111-1W.c4235a27.png";